import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useIntl } from 'react-intl';
import { StationAuditPage } from '../../components/StationAuditPage';
import { AudiosListView } from './AudiosListView';

export function StationAudiosListPage() {
  const station = useActiveStation();
  const { $t } = useIntl();

  return (
    <StationAuditPage
      title={$t({
        id: 'audit.audiosScreen.title',
        defaultMessage: 'Archivos',
      })}
    >
      <AudiosListView station={station} />
    </StationAuditPage>
  );
}
